const CreateButton = ({ type = "button", onClick, children }) => {
  return (
    <button
      onClick={onClick}
      type={type}
      className="
        rounded-lg border border-blue-500 px-4 py-2
        font-medium text-blue-500
        transition hover:bg-blue-500 hover:text-white
        cursor-pointer
        "
    >
      {children}
    </button>
  )
}

export default CreateButton
